<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group row">
                    <div class="col-md-12">
                        <!-- <yt-fw-dropdown
                            [ModelName]="'zanimanje'"
                            [GetName]="'get'"
                            [ModelProperty]="'Naziv'"
                            [OrderBy]="'Naziv'"
                            [AllowAddNew]='true'
                            [Required]='true'
                            [Disabled]='false'
                            formControlName="ZanimanjeID"
                            name="cmbZanimanje"
                            [Type]="ID"
                            [ngClass]="{'is-invalid': submitted && fc.ZanimanjeID.invalid}"
                            [Label]="'OSOBAZANIMANJE.ZANIMANJE.SINGULAR'">
                        </yt-fw-dropdown> -->
                        <yt-dropdown-picklist
                            [ModelName]="'zanimanje'"
                            [GetName]="'get'"
                            [ModelProperty]="'Naziv'"
                            [OrderBy]="'Naziv'"
                            [AllowAddNew]="true"
                            formControlName="ZanimanjeID"
                            [Label]="'OSOBAZANIMANJE.ZANIMANJE.SINGULAR'"    
                        >
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && fc.ZanimanjeID.invalid">
                            <span *ngFor="let validation of errorMessages.ZanimanjeID">
                                <span class="error-message" *ngIf="fc.ZanimanjeID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-md-12">
                        <!-- <yt-fw-dropdown
                            [ModelName]="'sprema'"
                            [GetName]="'get'"
                            [ModelProperty]="'Naziv'"
                            [OrderBy]="'Naziv'"
                            [AllowAddNew]='true'
                            [Required]='true'
                            [Disabled]='false'
                            formControlName="SpremaID"
                            name="cmbSprema"
                            [Type]="ID"
                            [ngClass]="{'is-invalid': submitted && fc.SpremaID.invalid}"
                            [Label]="'OSOBAZANIMANJE.SPREMA.SINGULAR'">
                        </yt-fw-dropdown> -->
                        <yt-dropdown-picklist
                            [ModelName]="'sprema'"
                            [GetName]="'get'"
                            [ModelProperty]="'Naziv'"
                            [OrderBy]="'Naziv'"
                            [AllowAddNew]="false"
                            formControlName="SpremaID"
                            [Label]="'OSOBAZANIMANJE.SPREMA.SINGULAR'"    
                        >
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && fc.SpremaID.invalid">
                            <span *ngFor="let validation of errorMessages.SpremaID">
                                <span class="error-message" *ngIf="fc.SpremaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            name="txtSkola"
                            formControlName="Skola"
                            [MaxLength]="200"
                            [ngClass]="{'is-invalid': submitted && fc.Skola.invalid}"
                            [Label]="'OSOBAZANIMANJE.SKOLA.SINGULAR'">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.Skola.invalid">
                            <span *ngFor="let validation of errorMessages.Skola">
                                <span class="error-message" *ngIf="fc.Skola.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            name="txtZvanje"
                            formControlName="Zvanje"
                            [MaxLength]="200"
                            [ngClass]="{'is-invalid': submitted && fc.Zvanje.invalid}"
                            [Label]="'OSOBAZANIMANJE.ZVANJE.SINGULAR'">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.Zvanje.invalid">
                            <span *ngFor="let validation of errorMessages.Zvanje">
                            <span class="error-message" *ngIf="fc.Zvanje.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
  